interface Props {
  score: number;
  showLabel?: boolean;
  className?: string;
}

function scoreColor(score: number): { bar: string; text: string } {
  if (score >= 75) return { bar: 'bg-green-500', text: 'text-green-700' };
  if (score >= 50) return { bar: 'bg-lime-500', text: 'text-lime-700' };
  if (score >= 25) return { bar: 'bg-amber-500', text: 'text-amber-700' };
  if (score > 0) return { bar: 'bg-orange-500', text: 'text-orange-700' };
  return { bar: 'bg-gray-300', text: 'text-gray-500' };
}

export default function LeadScoreBar({ score, showLabel = true, className = '' }: Props) {
  const clamped = Math.max(0, Math.min(100, score));
  const colors = scoreColor(clamped);

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <div className="relative h-1.5 w-16 bg-gray-200 rounded-full overflow-hidden">
        <div
          className={`absolute inset-y-0 left-0 ${colors.bar} transition-all`}
          style={{ width: `${clamped}%` }}
        />
      </div>
      {showLabel && (
        <span className={`text-xs font-semibold tabular-nums ${colors.text}`}>{clamped}</span>
      )}
    </div>
  );
}
